var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Page"},[_c('Header'),_c('div',{staticClass:"MaxWid"},[(_vm.typeId == 2)?_c('updateRegistration',{attrs:{"id":_vm.id,"uid":_vm.uid,"mode":_vm.mode}}):_c('userExercises',{attrs:{"id":_vm.id,"uid":_vm.uid,"mode":_vm.mode}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }